<template>
	<el-tabs>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-document-remove"></i>{{value.ming}}组件</span>
			<div style="padding: 20px;">
				<Biaodan v-model="value.shu" ming="Tu_"></Biaodan>
			</div>
		</el-tab-pane>
		<el-tab-pane>
			<span slot="label"><i class="el-icon-menu"></i> 组件样式</span>
			<div class="big_box" v-if="value.yangshi" style="margin-top: 10px;">
				<el-input v-model="value.yangshi.width" placeholder="px"> <template slot="prepend">宽度</template></el-input>
				<el-input v-model="value.yangshi.height" placeholder="px"> <template slot="prepend">高度</template></el-input>
				<el-input v-model="value.yangshi.text_align" placeholder="请输入内容"> <template slot="prepend">对齐</template></el-input>
				<el-input v-model="value.yangshi.margin" placeholder="px"> <template slot="prepend">外边距</template></el-input>
				<el-input v-model="value.yangshi.padding" placeholder="px"> <template slot="prepend">内边距</template></el-input>
				<el-input v-model="value.yangshi.border_radius" placeholder="px"> <template slot="prepend">圆角</template></el-input>
				<!-- <el-select v-model="value.yangshi.beijing" placeholder="请选择">
					<el-option label="图片" value="0" />
					<el-option label="图片11" value="1" />
				</el-select>
				<div class="block" style="justify-content: flex-start;display: flex;">
					<span class="demonstration colo_686 ziti_14">透明度</span>
					<el-slider v-model="value.touming"></el-slider>
				</div> -->
			</div>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	import Biaodan from '../Biaodan.vue'
	export default {
		data() {
			return {
				options: [{
					value: '选项1',
					label: '背景'
				}, {
					value: '选项2',
					label: '纯图片'
				}]
			}
		},
		components: {
			Biaodan
		},
		props: {
			value: {
				type: [Object, Array],
				default () {
					return {}
				}
			}
		},

	}
</script>
<style>
	@import url("Yangshi.css");
</style>
<!-- <link rel="stylesheet" href="Yangshi.css"> -->
